import React, { useState, useEffect } from 'react'
import './App.css'
import { Route, Switch, useLocation } from 'react-router-dom'
import NavigationBar from './NavigationBar/NavigationBar'
import { Page } from './const'
import { isAuthenticated } from './Controller'
import Authenticating from './Login/Authenticating'
import Deployment from './pages/Deployment/Deployment'
import Merge from './pages/Merge/Merge'
import TokenDialog from './Login/TokenDialog'

export function App() {
  const [authenticated, setAuthenticated] = useState(false)
  const location = useLocation()
  useEffect(() => {
    isAuthenticated().then(valid => {
      setAuthenticated(valid)
    })
  }, [location])

  if (authenticated) {
    return (
      <React.Fragment>
        <NavigationBar />
        <Switch>
          <Route exact path={Page.authenticating}>
            <Authenticating />
          </Route>
          <Route exact path={Page.deployment}>
            <Deployment />
          </Route>
          <Route exact path={Page.merge}>
            <Merge />
          </Route>
        </Switch>
        <TokenDialog />
      </React.Fragment>
    )
  } else {
    return <Authenticating />
  }
}

export default App
